import React from 'react';
import Icon from '../Icons/Icon';

export default class BreadCrumbs extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			resources: props.resources
		}
	}

	createBreadcrumbs(crumb, i) {
		let categoryID = {
			categoryID: crumb.CategoryID
		}
		return (
			<span key={"breadcrumb_" + i}>
				<div aria-hidden="true" className="breadcrumb-divider">&raquo;</div>
				<a role="menuitem" href="javascript:void(0);" onClick={this.props.SearchCategories.bind(this, categoryID)} title={`${this.state.resources['PWS.CategoryArea.BreadcrumbPageTitle']}, ${this.state.resources['PWS.CategoryArea.CategoryListCategoryTitle']}`} className="breadcrumb-item"><span>{crumb.CategoryName}</span></a>
			</span>
		)
	}

	render(){

		let Divider = <div aria-hidden="true" className="breadcrumb-divider">&raquo;</div>;

		let ParentCategory = typeof this.props.ActiveCategories !== "undefined" && this.props.ActiveCategories.selectedParentCategoryName.length > 0 ? <a role="menuitem" href="javascript:void(0);" title={this.state.resources['PWS.CategoryArea.BreadcrumbPageTitle'] + ', ' + this.state.resources['PWS.CategoryArea.CategoryListCategoryTitle']} className="breadcrumb-item"><span>{this.props.ActiveCategories.selectedParentCategoryName}</span></a> : '';

		let Category = typeof this.props.ActiveCategories !== "undefined" && this.props.ActiveCategories.selectedCategoryID.length > 0 ? <a role="menuitem" href="javascript:void(0);" title={this.state.resources['PWS.CategoryArea.BreadcrumbPageTitle'] + ', ' + this.state.resources['PWS.CategoryArea.CategoryListCategoryTitle']} className="breadcrumb-item"><span>{this.props.ActiveCategories.selectedCategoryName}</span></a> : '';

		return(
			<div id="breadcrumbs-wrapper" className="breadcrumbs-wrapper clearfix" role="menu">
				<a role="menuitem" href="javascript:void(0);" className="breadcrumb-item" onClick={this.props.resetAll.bind(this)}>{this.state.resources["PWS.CategoryArea.BreadcrumbPageTitle"]}</a>
				{this.props.breadcrumbsList.map(this.createBreadcrumbs.bind(this))}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductBrowse/BreadCrumbs.js